var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiyaPayImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 13,
    viewBox: "0 0 77 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "RiaPay",
    clipPath: "url(#clip0_47_13463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_47_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 13
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M77 0H0V13H77V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_47_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1782 12.2578L33.4119 9.3216C33.2865 9.1033 33.1042 8.92865 32.8763 8.79767C32.6712 8.66669 32.4432 8.59028 32.2039 8.57937H11.9084L11.464 7.84805H13.6405C13.8798 7.83713 14.1191 7.76073 14.3129 7.62974C14.5294 7.50968 14.7231 7.32412 14.8485 7.10581L18.6888 0.753169C18.7571 0.644017 18.7913 0.513034 18.8027 0.382052C18.8027 0.141918 18.6546 0.0218506 18.3583 0.0218506H7.66923C7.42992 0.0327658 7.20201 0.109172 6.99689 0.240155C6.78038 0.371137 6.59805 0.54578 6.47269 0.764084L0.193725 11.7229C0.0683735 11.9303 0 12.1705 0 12.4106C0 12.7162 0.239307 12.9673 0.558384 13H4.3987C4.58103 13 4.75196 12.869 4.9115 12.6071L6.63223 9.47441L8.31878 12.2578C8.44413 12.4761 8.62646 12.6507 8.85437 12.7817C9.05949 12.9127 9.28741 12.9891 9.52671 13H34.8591C35.144 13 35.2921 12.88 35.2921 12.6289C35.2807 12.4979 35.2466 12.3779 35.1782 12.2578ZM9.41276 6.92026C9.21903 7.05124 8.97972 7.12765 8.74042 7.13856C8.44413 7.13856 8.29599 7.01849 8.29599 6.77836C8.30738 6.64738 8.35297 6.51639 8.42134 6.41816L11.3728 1.4954C11.4981 1.2771 11.6805 1.10246 11.9084 0.971473C12.1135 0.84049 12.3414 0.764084 12.5807 0.753169C12.8656 0.753169 13.0138 0.873236 13.0138 1.12429C13.0024 1.25527 12.9682 1.37534 12.8998 1.4954L9.94835 6.40724C9.8116 6.61463 9.62927 6.78927 9.41276 6.92026Z",
    fill: "#009DE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_47_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 13
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M77 0H0V13H77V0Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_47_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.56 0H26.8709C26.6316 0.0109152 26.3923 0.0873216 26.1986 0.218304C25.982 0.349286 25.7883 0.52393 25.663 0.742234L24.7741 2.20487C24.7057 2.31402 24.6715 2.445 24.6601 2.57599C24.6601 2.81612 24.8083 2.93619 25.1046 2.9471H28.9335C29.1728 2.93619 29.4007 2.85978 29.5944 2.73971C29.811 2.61965 30.0047 2.43409 30.13 2.2267L30.5745 1.49538C30.7112 1.28799 30.8935 1.10243 31.1101 0.971453C31.3038 0.84047 31.5317 0.764064 31.771 0.753149C32.0559 0.753149 32.204 0.873216 32.204 1.12427C32.204 1.25525 32.1698 1.37531 32.1015 1.49538L31.224 2.93619C31.0873 3.14358 30.9049 3.31822 30.677 3.4492C30.4833 3.58018 30.244 3.65659 30.0047 3.66751H24.6601C24.4208 3.67842 24.1929 3.75483 23.9878 3.88581C23.7713 4.01679 23.5776 4.19144 23.4408 4.40974L21.6745 7.34593C21.6061 7.45508 21.5719 7.58606 21.5605 7.71704C21.5605 7.95718 21.7087 8.08816 22.005 8.08816H32.7054C32.9447 8.07725 33.1727 8.00084 33.3664 7.86986C33.5943 7.74979 33.7766 7.56423 33.902 7.34593L37.879 0.753149C37.9474 0.643997 37.9816 0.513014 37.993 0.382032C37.9816 0.120067 37.8448 0 37.56 0ZM29.8907 5.13014L29.0019 6.60369C28.8765 6.822 28.6942 6.99664 28.4663 7.11671C28.2612 7.24769 28.0332 7.3241 27.7939 7.33501C27.509 7.33501 27.3609 7.21495 27.3609 6.9639C27.3723 6.83291 27.4065 6.71285 27.4749 6.59278L28.3637 5.13014C28.4891 4.92275 28.6714 4.7372 28.8879 4.60621C29.0816 4.47523 29.3209 4.39882 29.5603 4.39882C29.8565 4.39882 30.0047 4.51889 30.0047 4.75903C30.0047 4.90092 29.9591 5.02099 29.8907 5.13014Z",
    fill: "#009DE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_47_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 13
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M77 0H0V13H77V0Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_47_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0193 2.69604C18.5977 2.69604 18.1988 2.91435 17.9937 3.26364L15.5436 7.335C15.4753 7.44416 15.4411 7.57514 15.4297 7.70612C15.4297 7.94625 15.5778 8.07724 15.8741 8.07724L19.8056 8.08815H19.8284C20.2044 8.08815 20.5577 7.90259 20.74 7.58605L21.2984 6.65826L21.3098 6.64735L21.9024 5.65406L22.0277 5.44667L23.2129 3.48194C23.418 3.14357 23.1673 2.71788 22.7571 2.71788H19.0193V2.69604Z",
    fill: "#009DE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_47_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 13
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M77 0H0V13H77V0Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_47_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9677 0.371117C24.9677 0.502099 24.9221 0.622166 24.8537 0.742233L24.2953 1.67003C24.1814 1.8665 23.9535 1.98657 23.7142 1.98657H19.4864C19.1673 1.98657 18.9622 1.65911 19.1217 1.38623L19.5092 0.742233C19.6345 0.523929 19.8169 0.349286 20.0448 0.218304C20.2499 0.0873216 20.4778 0.0109152 20.7171 0H24.5346C24.8309 0 24.9677 0.120067 24.9677 0.371117Z",
    fill: "#009DE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_47_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 13
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M77 0H0V13H77V0Z",
    fill: "white"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_47_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6193 0H39.9302C39.6909 0.0109152 39.463 0.0873216 39.2579 0.218304C39.0414 0.349286 38.859 0.523929 38.7337 0.742233L34.1413 8.17548C34.0159 8.38287 33.9475 8.623 33.9475 8.86314C33.9361 9.01595 33.9817 9.15785 34.0615 9.28883L36.1583 12.7271C36.2039 12.8144 36.295 12.8799 36.3976 12.8799C36.5799 12.8799 36.7508 12.749 36.9104 12.487L39.2351 8.80856C39.3604 8.59026 39.5428 8.41562 39.7707 8.28463C39.9644 8.15365 40.1923 8.07725 40.4316 8.06633H45.7762C46.0155 8.05542 46.2548 7.97901 46.4485 7.84803C46.665 7.71704 46.8587 7.5424 46.9841 7.3241L50.9612 0.731318C51.0295 0.622166 51.0637 0.491184 51.0751 0.360201C51.0637 0.120067 50.9156 0 50.6193 0ZM45.1722 1.47355L42.0954 6.60369C41.9586 6.81108 41.7763 6.99664 41.5484 7.12762C41.3547 7.25861 41.1154 7.33501 40.8761 7.34593C40.5798 7.34593 40.4316 7.22586 40.4316 6.97481C40.443 6.84383 40.4886 6.71285 40.557 6.61461L43.6452 1.48447C43.7705 1.26616 43.9529 1.09152 44.1808 0.960537C44.3859 0.829555 44.6138 0.753149 44.8531 0.742233C45.138 0.742233 45.2861 0.862301 45.2861 1.10243C45.2747 1.23342 45.2406 1.35348 45.1722 1.47355ZM76.5784 0H72.7609C72.5216 0.0109152 72.2823 0.0873216 72.0886 0.218304C71.8721 0.349286 71.6897 0.523929 71.553 0.742233L68.0204 6.60369C67.895 6.822 67.7127 6.99664 67.4848 7.12762C67.2796 7.25861 67.0517 7.33501 66.8124 7.34593C66.5275 7.34593 66.3794 7.22586 66.3794 6.97481C66.3794 6.84383 66.425 6.72376 66.4933 6.60369L70.026 0.742233C70.0943 0.633081 70.1285 0.502099 70.1399 0.371117C70.1399 0.130982 69.9918 0 69.7069 0H65.8894C65.6501 0.0109152 65.4108 0.0873216 65.217 0.218304C64.9891 0.349286 64.8068 0.523929 64.6814 0.742233L60.7044 7.33501C60.636 7.44416 60.6018 7.57515 60.5904 7.70613C60.5904 7.94626 60.7386 8.06633 61.0348 8.06633H64.9663V8.07725H66.1401C66.254 8.07725 66.3566 8.10999 66.4478 8.15365C66.5389 8.19731 66.6187 8.2628 66.6757 8.33921C66.7326 8.4047 66.7212 8.49202 66.6643 8.5466C66.6529 8.55751 66.6415 8.56843 66.6301 8.56843C66.6073 8.57934 66.5731 8.59026 66.5503 8.60118H40.6709C40.4316 8.61209 40.1923 8.6885 39.9986 8.81948C39.7707 8.93955 39.5883 9.1251 39.463 9.34341L37.6967 12.2796C37.6283 12.3887 37.5941 12.5197 37.5827 12.6507C37.5827 12.8908 37.7195 13.0218 38.0158 13.0218H68.8408C69.0801 13.0109 69.3194 12.9345 69.5132 12.8035C69.7411 12.6835 69.9234 12.4979 70.0488 12.2796L76.8975 0.731318C76.9659 0.622166 77.0001 0.491184 77.0115 0.360201C77.0001 0.120067 76.8633 0 76.5784 0Z",
    fill: "#009DE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_47_13463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 13
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M77 0H0V13H77V0Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_47_13463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.633 0H52.9439C52.7046 0.0109152 52.4653 0.0873216 52.2716 0.218304C52.055 0.349286 51.8613 0.523929 51.736 0.742233L50.8471 2.20487C50.7787 2.31402 50.7445 2.445 50.7331 2.57599C50.7331 2.81612 50.8813 2.93619 51.1776 2.9471H55.0065C55.2458 2.93619 55.4737 2.85978 55.6674 2.73971C55.884 2.61965 56.0777 2.43409 56.203 2.2267L56.6475 1.49538C56.7842 1.28799 56.9665 1.10243 57.183 0.971453C57.3768 0.84047 57.6047 0.764064 57.844 0.753149C58.1289 0.753149 58.277 0.873216 58.277 1.12427C58.277 1.25525 58.2428 1.37531 58.1745 1.49538L57.297 2.95802C57.1603 3.16541 56.9779 3.34005 56.75 3.47103C56.5563 3.60202 56.317 3.67842 56.0777 3.68934H50.7331C50.4938 3.70025 50.2659 3.77666 50.0608 3.90764C49.8443 4.03862 49.6506 4.21327 49.5138 4.43157L47.7475 7.36776C47.6791 7.47691 47.6449 7.60789 47.6335 7.73887C47.6335 7.97901 47.7817 8.10999 48.078 8.10999H58.767C59.0063 8.09908 59.2343 8.02267 59.428 7.89169C59.6559 7.77162 59.8382 7.58606 59.9636 7.36776L63.9406 0.774979C64.009 0.665827 64.0432 0.534845 64.0546 0.403862C64.066 0.120067 63.9178 0 63.633 0ZM55.9637 5.13014L55.0749 6.60369C54.9495 6.822 54.7672 6.99664 54.5393 7.11671C54.3342 7.24769 54.1062 7.3241 53.8669 7.33501C53.582 7.33501 53.4339 7.21495 53.4339 6.9639C53.4339 6.83291 53.4795 6.71285 53.5479 6.59278L54.4367 5.13014C54.5621 4.92275 54.7444 4.7372 54.9609 4.60621C55.1546 4.47523 55.3939 4.39882 55.6332 4.39882C55.9295 4.39882 56.0777 4.51889 56.0777 4.75903C56.0777 4.90092 56.0321 5.02099 55.9637 5.13014Z",
    fill: "#009DE0"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_13463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyaPayImage);
export default __webpack_public_path__ + "static/media/riyaPayImage.136e7f502dd07b53cb9be7241db05fe5.svg";
export { ForwardRef as ReactComponent };